// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { solutionCardStyles } from "@steiner/App/Widgets/Basic/SolutionCard";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

solutionCardStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        border: 1px solid ${color("common.border")};
    `,
};

solutionCardStyles.image = {
    css: css`
        img {
            aspect-ratio: 452 / 217;
        }
    `,
};

solutionCardStyles.title = {
    color: "common.white",
    typographyProps: {
        size: "20px",
        lineHeight: "24px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        background: ${color("primary")};
        padding: 8px 12px;
        display: block;
    `,
};

solutionCardStyles.description = {
    css: css`
        flex: 1;
        margin: 12px;
        ${ellipsis(3)}
        ${TypographyStyle} {
            margin-bottom: 0;
        }
    `,
};

solutionCardStyles.link = {
    css: css`
        padding: 0 12px;
        column-gap: 6px;
        justify-content: start;
        margin-bottom: 12px;
    `,

    icon: {
        position: "right",
        iconProps: {
            src: ArrowRight,
            size: 16,
            css: css`
                opacity: 0.66;
                margin-left: 0;
            `,
        },
    },
};
